import Layout from "../../components/Layout/Layout";
const Marketplace = () => {
  return (
    <Layout children={
      <div>Marketplace</div>
    }
    />
  );
};

export default Marketplace;
